document.addEventListener('DOMContentLoaded', function() {
  const contactForms = document.querySelectorAll('.custom-contact-form-section #ContactForm');
  if (contactForms?.length === 0) return;

  contactForms?.forEach(function(contactForm) {
    const requiredFields = [
      { id: 'ContactForm-name', fieldName: 'name', required: true, maxLength: 50, validate: value => /^[a-zA-Z\s.'\-]{3,}$/.test(value) },
      { id: 'ContactForm-email', fieldName: 'email', required: true, maxLength: 60, validate: value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) },
      { id: 'ContactForm-phone', fieldName: 'phone', required: true, validate: value => /^\+?[0-9\s\-()]+$/.test(value) },
      { id: 'ContactForm-country', fieldName: 'country', required: true, maxLength: 40, validate: value => /^[a-zA-Z\s\-]{3,}$/.test(value) },
      { id: 'ContactForm-city', fieldName: 'city', required: false, maxLength: 40, validate: value => /^[a-zA-Z\s\-]{3,}$/.test(value) },
      { id: 'ContactForm-company', fieldName: 'company', required: false, maxLength: 60, validate: value => /^[a-zA-Z0-9\s.'\-&,]{2,}$/.test(value) },
      { id: 'ContactForm-cutting-material', fieldName: 'cutting material', required: true },
      { id: 'ContactForm-machine-serial-no', fieldName: 'machine serial no', required: true, maxLength: 50, validate: value => /^[0-9]+$/.test(value) },
      { id: 'ContactForm-machine-type', fieldName: 'machine type',  required: true }
    ];

    const originalBtn = contactForm.querySelector('.contact__button button');
    if (!originalBtn) return;

    const newBtn = originalBtn.cloneNode(true);
    newBtn.type = 'button';
    originalBtn.parentNode.replaceChild(newBtn, originalBtn);

    const errorSummary = contactForm.querySelector('.form-error-summary');
    if (!errorSummary) return;

    requiredFields?.forEach(field => {
      const input = contactForm.querySelector(`#${field.id}`);
      if (!input) return;

      if (['name', 'country', 'city', 'company', 'machine-serial-no'].includes(field.fieldName)) {
        input.addEventListener('input', function(e) {
          e.target.value = e.target.value.replace(/[^a-zA-Z\s.'\-]/g, '');
        });
      }

      if (field.fieldName === 'email') {
        input.addEventListener('input', function(e) {
          e.target.value = e.target.value.toLowerCase();
        });
      }

      if (field.fieldName === 'phone') {
        input.addEventListener('input', function(e) {
          e.target.value = e.target.value.replace(/[^0-9+\-\s()]/g, '') ;
        });
      }

      input.addEventListener('input', function(e) {
        if (field.maxLength && e.target.value.length > field.maxLength) {
          e.target.value = e.target.value.slice(0, field.maxLength);
        }
        checkAllFieldsAndUpdateSummary();
      });
      
      input.addEventListener('blur', function() {
        validateField(input, field);
        checkAllFieldsAndUpdateSummary();
      });

      if (input.tagName === 'SELECT') {
        input.addEventListener('change', function() {
          validateField(input, field);
          checkAllFieldsAndUpdateSummary();
        });
      }
    });

    function validateField(input, fieldConfig) {
      const errorElement = input?.parentNode?.querySelector('.error-message');
      if (errorElement) {
        errorElement.style.display = 'none';
      }

      const value = input?.value?.trim();
      const isEmpty = input?.tagName === 'SELECT'
        ? !input?.value || input?.selectedIndex === 0
        : !value;

      if (isEmpty && fieldConfig.required === false) {
        return true;
      }

      if (isEmpty && fieldConfig.required !== false) {
        const message = input.tagName === 'SELECT'
          ? `Please select a ${fieldConfig.fieldName}.`
          : 'This field is required.';
        showFieldError(input, message);
        return false;
      }

      if (fieldConfig?.validate && !fieldConfig?.validate(value)) {
        let customMessage = 'Please enter a valid value.';

        switch (fieldConfig.fieldName) {
          case 'email':
            customMessage = 'Please enter a valid email address.';
            break;
          case 'phone':
            customMessage = 'Please enter a valid phone number.';
            break;
          case 'name':
            customMessage = 'Please enter a valid name.';
            break;
          case 'country':
            customMessage = 'Please enter a valid country name.';
            break;
          case 'city':
            customMessage = 'Please enter a valid city name.';
            break;
          case 'company':
            customMessage = 'Please enter a valid company name.';
            break;
        }

        showFieldError(input, customMessage);
        return false;
      }

      return true; 
    }


    function showFieldError(input, message = 'Please enter a valid value.') {
      const errorElement = input.parentNode.querySelector('.error-message');
      if (errorElement) {
        errorElement.textContent = message;
        errorElement.style.display = 'block';
      }
      return false;
    }
    
    function checkAllFieldsAndUpdateSummary() {
      let allValid = true;
      
      requiredFields?.forEach(field => {
        const input = contactForm.querySelector(`#${field?.id}`);
        if (!input) return;

        const errorElement = input.parentNode.querySelector('.error-message');
        const hasError = errorElement && errorElement.style.display === 'block';
        
        const isEmpty = input?.tagName === 'SELECT' 
          ? !input?.value || input?.selectedIndex === 0
          : !input?.value?.trim();

        if (hasError || isEmpty) {
          allValid = false;
        }
      });

      if (allValid) {
        errorSummary.style.display = 'none';
      }
    }

    function validateAndSubmit(e) {
      e && e.preventDefault();
      let isValid = true;
      
      contactForm.querySelectorAll('.error-message').forEach(el => {
        el.style.display = 'none';
      });
      
      errorSummary.style.display = 'none';

      requiredFields?.forEach(field => {
        const input = contactForm.querySelector(`#${field?.id}`);
        if (!input) return;
        
        const fieldValid = validateField(input, field);
        if (!fieldValid) {
          isValid = false;
        }
      });

      if (isValid) {
        newBtn.disabled = true;
        const hiddenSubmit = document.createElement('button');
        hiddenSubmit.type = 'submit';
        hiddenSubmit.style.display = 'none';
        contactForm?.appendChild(hiddenSubmit);
        hiddenSubmit?.click();
        contactForm?.removeChild(hiddenSubmit);
      } else {
        errorSummary.style.display = 'block';
        errorSummary.textContent = 'Some fields are invalid. Please correct the highlighted ones.';
        const firstError = contactForm.querySelector('.error-message[style="display: block;"]');
        if (firstError) {
          firstError.parentNode.querySelector('input, select, textarea').focus();
          firstError.parentNode.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }

    newBtn?.addEventListener('click', validateAndSubmit);
    contactForm?.addEventListener('submit', function(e) {
      const hasErrors = contactForm.querySelectorAll('.error-message[style="display: block;"]')?.length > 0;
      if (hasErrors) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    checkAllFieldsAndUpdateSummary();
  });
});
window.addEventListener('load', function() {
  const successMsgs = document.querySelectorAll('.form__message');
  if (successMsgs.length > 0) {
    successMsgs.forEach((msg) => {
      const text = msg.textContent.trim();
      if (text !== '') {
        setTimeout(() => {
          msg.style.display = 'none';
        }, 5000);
      }
    });
  }
});


